export const policyDropdownItems = {
  "INPUT PRODUCTION POLICIES": [
    {
      heading: "Input and Production Support Policies",
      items: [
        {
          label: "Fertilizer Subsidy Programs – e.g., Nigeria’s Growth Enhancement Support Scheme (GESS)",
          value: "FSP"
        },
        {
          label: "Seed Distribution and Quality Control Policies – support for improved seed varieties",
          value: "SDQ"
        },
        {
          label: "Irrigation and Water Resource Management Policies – expanding smallholder irrigation systems",
          value: "IWM"
        },
        {
          label: "Mechanization Support Policies – subsidizing tractors and farm equipment",
          value: "MSP"
        }
      ]
    }
  ],

  "LAND TENURE POLICIES": [
    {
      heading: "Land and Resource Tenure Policies",
      items: [
        {
          label: "Land Reform and Tenure Security Policies – formalizing land ownership (e.g., Ethiopia's land certification)",
          value: "LRT"
        },
        {
          label: "Customary Land Rights Recognition – integrating traditional land rights into national policy",
          value: "CLR"
        },
        {
          label: "Pastoral Land Use and Grazing Rights Policies – managing access to communal lands",
          value: "PLG"
        }
      ]
    }
  ],

  "MARKET TRADE POLICIES": [
    {
      heading: "Market and Trade Policies",
      items: [
        {
          label: "Price Stabilization and Minimum Support Prices – guaranteed prices for crops like maize or rice",
          value: "PSP"
        },
        {
          label: "Export/Import Regulations – tariffs, bans, or quotas on agricultural goods",
          value: "EIR"
        },
        {
          label: "Commodity Exchange and Warehouse Receipt Systems – improving market access and storage",
          value: "CEW"
        },
        {
          label: "Public Procurement Policies – e.g., school feeding programs buying from local farmers",
          value: "PPP"
        }
      ]
    }
  ],

  "AGRICULTURE FINANCE": [
    {
      heading: "Agricultural Finance and Insurance",
      items: [
        {
          label: "Rural Credit and Microfinance Schemes – increasing access to capital for farmers",
          value: "RCM"
        },
        {
          label: "Agricultural Insurance Programs – crop and livestock insurance to manage risk",
          value: "AIP"
        },
        {
          label: "Blended Finance and Public-Private Partnerships (PPPs) – attracting private investment in agriculture",
          value: "BFP"
        }
      ]
    }
  ],

  "RESEARCH INNOVATION": [
    {
      heading: "Research, Extension, and Innovation",
      items: [
        {
          label: "National Agricultural Research Policies – support for research institutions like CGIAR partners",
          value: "NAR"
        },
        {
          label: "Agricultural Extension Services – training and advisory services for farmers",
          value: "AES"
        },
        {
          label: "Digital Agriculture and ICT Policies – using mobile and satellite tech for information delivery",
          value: "DAP"
        }
      ]
    }
  ],

  "FOOD SECURITY ...........": [
    {
      heading: "Food Security and Nutrition Policies",
      items: [
        {
          label: "Strategic Grain Reserves – buffer stocks to stabilize supply and prices",
          value: "SGR"
        },
        {
          label: "Nutrition-Sensitive Agriculture – promoting diverse diets and biofortified crops",
          value: "NSA"
        },
        {
          label: "Emergency Food Distribution Policies – responses to droughts or conflict-driven shortages",
          value: "EFD"
        }
      ]
    }
  ],

  "CLIMATE CHANGE  ...........": [
    {
      heading: "Climate Change and Environmental Sustainability",
      items: [
        {
          label: "Climate-Smart Agriculture (CSA) Policies – adaptation and mitigation strategies",
          value: "CSA"
        },
        {
          label: "Soil Conservation and Reforestation Policies – combating desertification and degradation",
          value: "SCR"
        },
        {
          label: "Water Use and Management Policies – sustainable water harvesting and conservation",
          value: "WUM"
        }
      ]
    }
  ],

  "GENDER YOUTH  ............": [
    {
      heading: "Gender and Youth Inclusion",
      items: [
        {
          label: "Women in Agriculture Support Policies – access to land, finance, and services for women farmers",
          value: "WAS"
        },
        {
          label: "Youth in Agribusiness Initiatives – employment and entrepreneurship opportunities in farming",
          value: "YAI"
        }
      ]
    }
  ],

  "INSTITUTIONAL REFORMS": [
    {
      heading: "Institutional and Governance Reforms",
      items: [
        {
          label: "Decentralization of Agricultural Services – empowering local governments",
          value: "DAS"
        },
        {
          label: "Agricultural Policy Harmonization – e.g., ECOWAS, SADC, or CAADP-aligned policies",
          value: "APH"
        },
        {
          label: "Anti-Corruption and Transparency Mechanisms – improving efficiency and reducing leakages",
          value: "ACT"
        }
      ]
    }
  ],

  "REGIONAL FRAMEWORKS": [
    {
      heading: "Regional and Continental Frameworks",
      items: [
        {
          label: "CAADP (Comprehensive Africa Agriculture Development Programme) – AU-led policy framework promoting 10% budget allocation to agriculture",
          value: "CAA"
        },
        {
          label: "Malabo Declaration Commitments – goals on food security, resilience, and poverty reduction",
          value: "MDC"
        },
        {
          label: "Regional Agricultural Investment Plans (RAIPs) – e.g., under COMESA, ECOWAS",
          value: "RAI"
        }
      ]
    }
  ]
};